import { isDigitalLoanPreviewTarget } from 'utils/digitalLoanPreviewAccess';

/** Misma clave que CmsBlocks v2: /home → home. */
export function getCurrentCmsPageKey() {
  return document.location.pathname.replace(/\//g, '-').replace(/^-/g, '');
}

function readCmsLink(link) {
  if (typeof link === 'string') {
    return link;
  }
  if (link && typeof link === 'object') {
    return link.link || link.url || '';
  }
  return '';
}

/**
 * El item legado de Préstamo de Cercanía se reconoce por su destino,
 * no por el copy (el CMS puede cambiar el título de prueba).
 */
export function isDigitalLoanCmsLink(link) {
  let target = readCmsLink(link).trim();
  if (!target) {
    return false;
  }
  if (target.startsWith('http://') || target.startsWith('https://')) {
    return false;
  }
  if (!target.startsWith('/')) {
    target = `/${target}`;
  }
  return isDigitalLoanPreviewTarget(target);
}

export function isLegacyDigitalLoanCmsItem(item) {
  const link = item?.value?.link ?? item?.link;
  return isDigitalLoanCmsLink(link);
}

const DIGITAL_LOAN_CMS_BLOCK_TYPES = ['SimpleCardList', 'CardsCarousel'];

export function pagePublishesDigitalLoanCard(blocks) {
  return (blocks || []).some((block) => (
    DIGITAL_LOAN_CMS_BLOCK_TYPES.includes(block?.type)
    && (block.value?.items || []).some(isLegacyDigitalLoanCmsItem)
  ));
}
